export const ADD_UNDOABLE = 'artful-client/Undo/ADD_UNDOABLE';

export const CLEAR_UNDOABLE = 'artful-client/Undo/CLEAR_UNDOABLE';
